import Department from '../models/department';

export const DEPARTMENTS: Array<Department> = [Department.getInstanceFromObject({
    id: '432bbadf-7fea-4a97-b5fa-6aff9dcc5ca6',
    name: 'Maintenance',
})];
